import { z } from 'zod';
import { extend } from './extend.js';

export enum CallRole {
  Unknown = 0,
  Scheduler = 1,
  Respondent = 2,
  Attendee = 3,
  PrimaryRespondent = 4,
  ModeratorAttendee = 5,
}

export const CallRoleSchema = z.enum(CallRole);

export const CallRole_Utils = extend(
  new Map([
    [CallRole.Scheduler, { name: `Moderator` }],
    [CallRole.Respondent, { name: `Respondent` }],
    [CallRole.Attendee, { name: `Attendee` }],
    [CallRole.PrimaryRespondent, { name: `Respondent` }],
    [CallRole.ModeratorAttendee, { name: `Moderator` }],
    [CallRole.Unknown, { name: `Unknown` }],
  ])
);

export enum CallChargeOverrideType {
  Custom = 'custom-rate',
  Group = 'group-rate',
  Project = 'project-rate',
  ProjectLink = 'project-link-rate',
}

export enum CallPayoutOverrideType {
  Custom = 'custom-rate',
  Project = 'project-rate',
  ProjectLink = 'project-link-rate',
}

export enum CallStatus {
  Scheduled = 1,
  Completed = 2,
  Rejected = 3,
  Pending = 4,
  Rescheduling = 5,
  Cancelled = 6,
  MissedByClient = 7,
}

const statusMap = new Map([
  [CallStatus.Scheduled, { name: 'Scheduled' }],
  [CallStatus.Completed, { name: 'Completed' }],
  [CallStatus.Rejected, { name: 'Rejected' }],
  [CallStatus.Pending, { name: 'Pending' }],
  [CallStatus.Rescheduling, { name: 'Rescheduling' }],
  [CallStatus.Cancelled, { name: 'Cancelled' }],
  [CallStatus.MissedByClient, { name: 'Missed' }],
]);

export enum CallType {
  Project = 1,
  AdHoc = 2,
}

const type = new Map([
  [CallType.Project, { name: 'Project' }],
  [CallType.AdHoc, { name: 'Ad Hoc' }],
]);

export enum CallTranscriptionStatus {
  InProgress = 1,
  Completed = 2,
  Failed = 3,
}

export default {
  CallRole: CallRole_Utils,
  CallStatus: extend(statusMap),
  CallType: extend(type),
};
